<template>
  <div>
    <div class="mt-3 mb-4 field-of-fields" style="width: 75%; display: block; margin-left: auto; margin-right: auto;">
      <a href="https://www.goldcoastnannies.company/">
        <img src="../../../assets/img/logo/GoldCoastNannies_Logo_FullColor-01.png" width="" height="60" :alt="$store.getters.agencyName" style="" id='' class="center">
      </a>
      <h1 class="center mt-5">Family Form - Nanny</h1>
      <div class="mt-3 center">
        <p>Not sure if you are ready to go ahead?</p>
        <div style="margin-top: 18px; margin-bottom: 30px;">
          <a href="" class="mylisting-button dark-button" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/sarah-goldcoastnannies/15min'});return false;">Book a Call With Us</a>
        </div>
      </div>

      <hr>
      <h3 style="">Contact Information</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px;">
      <!-- <label>Family Name*</label> -->
      <!-- <input type="text" class="form-control" placeholder="eg. Smith" v-model="familyName"> -->
      <!-- <label style="color: red; margin-top: 3px;" v-if="!familyName && submitClicked">This field is required.</label> -->
      <!-- <p class="required-message" v-if="!familyName && submitClicked">This field is required.</p> -->
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>First Name*</label>
            <input type="text" class="form-control" v-model="motherFirst">
            <p class="required-message" v-if="!motherFirst && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Last Name*</label>
            <input type="text" class="form-control" v-model="motherLast">
            <p class="required-message" v-if="!motherLast && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Spouse/Partner First Name</label>
            <input type="text" class="form-control" v-model="fatherFirst">
            <!-- <p class="required-message" v-if="!fatherFirst && submitClicked">This field is required.</p> -->
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Spouse/Partner Last Name</label>
            <input type="text" class="form-control" v-model="fatherLast">
            <!-- <p class="required-message" v-if="!fatherLast && submitClicked">This field is required.</p> -->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Email Address*</label>
            <input type="text" class="form-control" v-model="motherEmail" placeholder="">
            <p class="required-message" v-if="!motherEmail && submitClicked">This field is required.</p>
            <p class="required-message" v-if="motherEmail && (validEmailFormat.test(motherEmail) === false)">Please enter a valid email.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Phone Number*</label>
            <input type="text" class="form-control" v-model="motherPhone" placeholder="Please include area code.">
            <p class="required-message" v-if="!motherPhone && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Father's First Name*</label>
            <input type="text" class="form-control" v-model="fatherFirst">
            <p class="required-message" v-if="!fatherFirst && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Father's Last Name*</label>
            <input type="text" class="form-control" v-model="fatherLast">
            <p class="required-message" v-if="!fatherLast && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Father's Email Address*</label>
            <input type="text" class="form-control" v-model="fatherEmail" placeholder="">
            <p class="required-message" v-if="!fatherEmail && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Father's Phone Number*</label>
            <input type="text" class="form-control" v-model="fatherPhone" placeholder="Please include area code.">
            <p class="required-message" v-if="!fatherPhone && submitClicked">This field is required.</p>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-lg-4">
          <label>City*</label>
          <input type="text" class="form-control" v-model="city">
          <p class="required-message" v-if="!city && submitClicked">This field is required.</p>
        </div>
        <div class="col-lg-4">
          <label>State*</label>
          <input type="text" class="form-control" v-model="state">
          <p class="required-message" v-if="!state && submitClicked">This field is required.</p>
        </div>
        <div class="col-lg-4">
          <div>
            <label>Zip Code*</label>
            <input type="text" class="form-control" v-model="postalCode">
            <p class="required-message" v-if="!postalCode && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>
      <!-- <label>Which is the best and most prompt way we can get into contact with you?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Email" v-model="preferredComm">
        <label class="form-check-label ml-1" for="exampleRadios1">
          Email
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Phone" v-model="preferredComm">
        <label class="form-check-label ml-1" for="exampleRadios2">
          Phone
        </label>
      </div>
      <p class="required-message" v-if="!preferredComm && submitClicked">This field is required.</p> -->

      <h3 style="" class="mt-5">Service Information</h3>
      <hr style="margin-top: 3px; margin-bottom: -5px;">
      <!-- <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Child Name*</label>
            <input type="text" class="form-control" v-model="child1">
            <p class="required-message" v-if="!child1 && submitClicked">This field is required.</p>
            <label>Child Name</label>
            <input type="text" class="form-control" v-model="child2">
            <label>Child Name</label>
            <input type="text" class="form-control" v-model="child3">
            <label>Child Name</label>
            <input type="text" class="form-control" v-model="child4">
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Birthday*</label>
            <datepicker class="form-control" initial-view="year" v-model="birthday1" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
            <p class="required-message" v-if="!birthday1 && submitClicked">This field is required.</p>
            <label>Birthday</label>
            <datepicker class="form-control" initial-view="year" v-model="birthday2" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
            <label>Birthday</label>
            <datepicker class="form-control" initial-view="year" v-model="birthday3" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
            <label>Birthday</label>
            <datepicker class="form-control" initial-view="year" v-model="birthday4" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
          </div>
        </div>
      </div> -->
      <div class="row">
        <div class="col-lg-6">
          <div>
            <label>Number of Children*</label>
            <input type="text" class="form-control" v-model="numberChildren">
            <p class="required-message" v-if="!numberChildren && submitClicked">This field is required.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div>
            <label>Age of Children*</label>
            <input type="text" class="form-control" v-model="ageChildren">
            <p class="required-message" v-if="!ageChildren && submitClicked">This field is required.</p>
          </div>
        </div>
      </div>
      <label>Does your child have any special needs or medical conditions?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes" v-model="childConditions">
        <label class="form-check-label ml-1" for="childConditionsRadios">
          Yes
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="No" v-model="childConditions">
        <label class="form-check-label ml-1" for="childConditionsRadios">
          No
        </label>
      </div>
      <p class="required-message" v-if="!childConditions && submitClicked">This field is required.</p>
      <div v-if="childConditions == 'Yes'">
        <label style="margin-top: 3px;">Please Explain*</label>
        <textarea rows="4" class="form-control" v-model="childConditionsExplanation" placeholder=""></textarea>
      </div>
      <label>Pay Rate*</label>
      <input type="text" class="form-control" v-model="payRate" placeholder="">
      <p class="required-message" v-if="!payRate && submitClicked">This field is required.</p>
      <label>Please describe your family schedule.*</label>
      <textarea rows="4" class="form-control" v-model="familySchedule" placeholder=""></textarea>
      <p class="required-message" v-if="!familySchedule && submitClicked">This field is required.</p>
      <label>Please describe any household tasks your nanny will be expected to perform:*</label>
      <textarea rows="4" class="form-control" v-model="householdTasks" placeholder=""></textarea>
      <p class="required-message" v-if="!householdTasks && submitClicked">This field is required.</p>
      <label>Please describe your family philosophies regarding childcare, discipline, etc.*</label>
      <textarea rows="4" class="form-control" v-model="familyPhilosophies" placeholder=""></textarea>
      <p class="required-message" v-if="!familyPhilosophies && submitClicked">This field is required.</p>

      <label>Does your child need to be taken to after school activity?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes" v-model="afterSchoolActivity">
        <label class="form-check-label ml-1" for="afterSchoolActivityRadios">
          Yes
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="No" v-model="afterSchoolActivity">
        <label class="form-check-label ml-1" for="afterSchoolActivityRadios">
          No
        </label>
      </div>
      <p class="required-message" v-if="!afterSchoolActivity && submitClicked">This field is required.</p>
      <div v-if="afterSchoolActivity == 'Yes'">
        <label style="margin-top: 3px;">Please Explain*</label>
        <textarea rows="4" class="form-control" v-model="afterSchoolActivityExplanation" placeholder=""></textarea>
      </div>

      <label>Do you encourage play dates? If so, in your home or away?*</label>
      <textarea rows="4" class="form-control" v-model="playDates" placeholder=""></textarea>
      <p class="required-message" v-if="!playDates && submitClicked">This field is required.</p>
      <label>Will you provide paid vacation or holidays for your nanny?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Vacation" v-model="vacation">
        <label class="form-check-label ml-1" for="vacationRadios">
          Vacation
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Holidays" v-model="vacation">
        <label class="form-check-label ml-1" for="vacationRadios">
          Holidays
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Vacation and Holidays" v-model="vacation">
        <label class="form-check-label ml-1" for="vacationRadios">
          Vacation and Holidays
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="None" v-model="vacation">
        <label class="form-check-label ml-1" for="vacationRadios">
          None
        </label>
      </div>
      <p class="required-message" v-if="!vacation && submitClicked">This field is required.</p>
      <div v-if="vacation && vacation != 'None'">
        <label style="margin-top: 3px;">Please Explain*</label>
        <textarea rows="4" class="form-control" v-model="vacationExplanation" placeholder=""></textarea>
      </div>
      <label>Please explain any special privileges given to the nanny:</label>
      <textarea rows="4" class="form-control" v-model="privileges" placeholder=""></textarea>
      <label>Describe your home:*</label>
      <textarea rows="4" class="form-control" v-model="home" placeholder=""></textarea>
      <p class="required-message" v-if="!home && submitClicked">This field is required.</p>
      <label>Describe your neighborhood:*</label>
      <textarea rows="4" class="form-control" v-model="neighborhood" placeholder=""></textarea>
      <p class="required-message" v-if="!neighborhood && submitClicked">This field is required.</p>
      <label>Describe your overall experience with nannies:*</label>
      <textarea rows="4" class="form-control" v-model="experience" placeholder=""></textarea>
      <p class="required-message" v-if="!experience && submitClicked">This field is required.</p>
      <label>If family has had a previous nanny, please explain how long each nanny was with your family:*</label>
      <textarea rows="4" class="form-control" v-model="previousNannies" placeholder=""></textarea>
      <p class="required-message" v-if="!previousNannies && submitClicked">This field is required.</p>
      <label>Do you have pets? If so, please describe them:*</label>
      <textarea rows="4" class="form-control" v-model="pets" placeholder=""></textarea>
      <p class="required-message" v-if="!pets && submitClicked">This field is required.</p>
      <label>Do you have a housekeeper:*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes" v-model="housekeeper">
        <label class="form-check-label ml-1" for="housekeeperRadios">
          Yes
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="No" v-model="housekeeper">
        <label class="form-check-label ml-1" for="housekeeperRadios">
          No
        </label>
      </div>
      <p class="required-message" v-if="!housekeeper && submitClicked">This field is required.</p>

      <label>Will your nanny be expected to prepare meals?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes" v-model="meals">
        <label class="form-check-label ml-1" for="mealsRadios">
          Yes
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="No" v-model="meals">
        <label class="form-check-label ml-1" for="mealsRadios">
          No
        </label>
      </div>
      <p class="required-message" v-if="!meals && submitClicked">This field is required.</p>

      <label>Will your nanny be required to travel with the family?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes" v-model="travel">
        <label class="form-check-label ml-1" for="travelRadios">
          Yes
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="No" v-model="travel">
        <label class="form-check-label ml-1" for="travelRadios">
          No
        </label>
      </div>
      <p class="required-message" v-if="!travel && submitClicked">This field is required.</p>
      <div v-if="travel == 'Yes'">
        <label style="margin-top: 3px;">Please Explain*</label>
        <textarea rows="4" class="form-control" v-model="travelExplanation" placeholder=""></textarea>
      </div>

      <label>Do you or your spouse work from home?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes, I do" v-model="wfh">
        <label class="form-check-label ml-1" for="wfhRadios">
          Yes, I do
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes, my spouse does" v-model="wfh">
        <label class="form-check-label ml-1" for="wfhRadios">
          Yes, my spouse does
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes, both my spouse and I do" v-model="wfh">
        <label class="form-check-label ml-1" for="wfhRadios">
          Yes, both my spouse and I do
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="No" v-model="wfh">
        <label class="form-check-label ml-1" for="wfhRadios">
          No
        </label>
      </div>
      <p class="required-message" v-if="!vacation && submitClicked">This field is required.</p>

      <label>Is the nanny required to have their own car?*</label>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Yes" v-model="car">
        <label class="form-check-label ml-1" for="wfhRadios">
          Yes
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="No" v-model="car">
        <label class="form-check-label ml-1" for="wfhRadios">
          No
        </label>
      </div>
      <div class="form-check pl-4">
        <input class="form-check-input" type="radio" value="Other" v-model="car">
        <label class="form-check-label ml-1" for="wfhRadios">
          Other
        </label>
        <input type="text" class="form-control" v-model="carOther">
      </div>
      <p class="required-message" v-if="!car && submitClicked">This field is required.</p>

      <label>Total Hours Expected to Work Each Week*</label>
      <input type="text" class="form-control" v-model="expectedHours">
      <p class="required-message" v-if="!expectedHours && submitClicked">This field is required.</p>

      <label>Days/Hours*</label>
      <textarea rows="4" class="form-control" v-model="schedule" placeholder=""></textarea>
      <p class="required-message" v-if="!schedule && submitClicked">This field is required.</p>

      <label>Start Date*</label>
      <datepicker class="form-control" v-model="startDate" :disabled-dates="disabledDates" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
      <p class="required-message" v-if="!startDate && submitClicked">This field is required.</p>

      <label>How did you hear about us?</label>
      <input type="text" class="form-control" v-model="referrer">

      <div class="" style="margin-top: 30px; margin-bottom: 80px;">
        <div style="display: block;">
          <button class="mylisting-button dark-button" style="float: right;" @click="submitApplication()">Submit</button>
        </div>
      </div>
      <div style="margin-bottom: 130px">
        <p v-if="requiredMissing" class="required-message" style="float: right;">A required field is missing, please check the form.</p>
      </div>

    </div>

    <modal name="required-missing-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>A required field is missing.</h2>
        <h4>Please review the form for error messages!</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('required-missing-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="duplicate-email-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Your email is already in our system!</h2>
        <h4>Have you worked with us before? If you think this is an error, please contact us: sarah@goldcoastnannies.company</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('duplicate-email-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="application-submitted-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Thank you for submitting your application!</h2>
        <hr>
        <h5>If we have not already had a conversation, the next step is to book a call to review it with us. If we have spoken already, we'll be in touch shortly!</h5>
        <!-- <h4>You can safely close this window.</h4> -->
        <!-- <p>Not sure if you are ready to go ahead?</p> -->
        <div style="margin-top: 25px; margin-bottom: 30px;">
          <a href="" class="mylisting-button dark-button" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/sarah-goldcoastnannies/15min'});return false;">Book a Call With Us</a>
        </div>
        <h6>If you don't see a time slot that works for you, please email sarah@goldcoastnannies.company</h6>
        <hr>
        <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('application-submitted-modal')" style="">Close</button> -->
        <button class="mylisting-button secondary-button" @click="hideApplicationSubmittedModal()" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
// import { required, numeric } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

export default {
  components: {
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data() {
    return {
      familyName: '',
      motherFirst: '',
      motherLast: '',
      motherEmail: '',
      motherPhone: '',
      fatherFirst: '',
      fatherLast: '',
      fatherEmail: '',
      fatherPhone: '',
      address: '',
      city: '',
      state: '',
      postalCode: '',
      // preferredComm: '',
      // child1: '',
      // birthday1: '',
      // child2: '',
      // birthday2: '',
      // child3: '',
      // birthday3: '',
      // child4: '',
      // birthday4: '',
      numberChildren: '',
      ageChildren: '',
      childConditions: '',
      childConditionsExplanation: '',
      payRate: '',
      familySchedule: '',
      householdTasks: '',
      familyPhilosophies: '',
      afterSchoolActivity: '',
      afterSchoolActivityExplanation: '',
      playDates: '',
      vacation: '',
      vacationExplanation: '',
      privileges: '',
      home: '',
      neighborhood: '',
      experience: '',
      previousNannies: '',
      pets: '',
      housekeeper: '',
      meals: '',
      travel: '',
      travelExplanation: '',
      wfh: '',
      car: '',
      carOther: '',
      expectedHours: '',
      schedule: '',
      positions: [],
      duration: '',
      startDate: null,
      // notes: '',
      referrer: '',
      // referee: '',

      submitClicked: false,
      requiredMissing: false,
      invalidEmail: false,
      validEmailFormat: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    }
  },
  computed: {
    disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      let today = new Date()
      let disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
      return disabledDates
    },
  },
  created() {
    window.location.href = 'https://nanniescoasttocoast.enginehire.io/application-form/20/210';
  },
  methods: {
    submitApplication() {
      // this.$modal.show('application-submitted-modal')
      this.submitClicked = true
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

      if (this.validEmailFormat.test(this.motherEmail) === false) {
        this.invalidEmail = true
      } else {
        this.invalidEmail = false
      }

      if (this.motherFirst && this.motherLast && this.motherEmail && this.motherPhone
          && this.city && this.state && this.postalCode
          && this.numberChildren && this.ageChildren && this.childConditions
          && this.payRate && this.familySchedule && this.householdTasks && this.familyPhilosophies
          && this.afterSchoolActivity && this.playDates && this.vacation
          && this.home && this.neighborhood && this.experience && this.previousNannies && this.pets && this.housekeeper
          && this.meals && this.travel && this.wfh && this.car && this.expectedHours
          && this.schedule && this.startDate && this.invalidEmail === false
      ){
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },7500)

        // axios.post('/create-user/', {
        //   email: this.motherEmail,
        //   password: this.motherEmail,
        // })
        //   .then(res => {
        //     console.log('User resgistered!')
        //     console.log(res)
        //     console.log(res.data.pk)

        //     console.log(this.$store.getters.agencyID)
        //     console.log(this.$store.getters.agencyName)

        //     axios.patch('/api/people/'.concat(res.data.pk.toString())+'/',
        //       {
        //         agency: this.$store.getters.agencyID,
        //         agency_owner: this.$store.getters.agencyName,
        //         is_employer: true,
        //         status: 'Applied',
        //       }
        //     )
        //       .then(res => {
        //         console.log(res)
        //       })
        //       .catch(error => console.log(error))
        //   })
        //   .catch(error => console.log(error))

        this.$store.dispatch('registerUser', {email: this.motherEmail, password: this.motherEmail, user_type: 'employer', status: 'Applied', phone: this.motherPhone})
          .then(() => {
            console.log('Done registration')
            // Send myself an email notification that a new client started a quote
            this.$store.dispatch('sendEmails',
              {
                subject: 'New Family Form Submission',
                message: 'New Family Form submitted by: ' + this.motherFirst + ' ' + this.motherLast + ' | ' + this.motherEmail + '\nPlease log into the administrator dashboard to view it!',
                // from: 'info@thrivehire.co',
                from: this.$store.getters.agencyFromEmail,
                // emails: [this.$store.getters.enginehireAdminEmail],
                emails: [this.$store.getters.enginehireLoggingEmail, this.$store.getters.agencyAdminEmail, this.$store.getters.agencyAdminEmail2],
                reply: this.$store.getters.agencyReplyEmail,
                // userID: this.aakashid,
                userID: 4,
              }
            )
            // this.$store.dispatch('sendEmail',
            //   {
            //     subject: 'New TNC Permanent Nanny Client Application',
            //     message: 'New Permanent Nanny Application submitted by: ' + this.motherFirst + ' ' + this.motherLast + ' | ' + this.motherEmail,
            //     // from: 'info@thrivehire.co',
            //     from: this.$store.getters.agencyFromEmail,
            //     email: this.$store.getters.agencyAdminEmail,
            //     reply: this.$store.getters.agencyReplyEmail,
            //     // userID: this.aakashid,
            //     userID: 4,
            //   }
            // )

            if (this.startDate) {
              this.startDate = this.dateInDjangoFormat(this.startDate)
            }

            // if (this.carOther) {
            //   this.car = this.carOther
            // }

            // Need to store all the contact info after creating the user
            axios.patch('/api/people/'+this.$store.getters.userID.toString()+'/', {
              // selector1: 'Permanent',
              // employer_name: this.familyName,
              first_name: this.motherFirst,
              last_name: this.motherLast,
              phone: this.motherPhone,
              features: [this.fatherFirst, this.fatherLast],
              // address1: this.address,
              postal_code: this.postalCode,
              city: this.city,
              provincestate: this.state,

              text1: this.numberChildren,
              text2: this.ageChildren,
              selector1: this.childConditions,
              text3: this.childConditionsExplanation,
              text4: this.payRate,
              text5: this.familySchedule,
              text6: this.householdTasks,
              text7: this.familyPhilosophies,
              selector2: this.afterSchoolActivity,
              text8: this.afterSchoolActivityExplanation,
              text9: this.playDates,
              selector3: this.vacation,
              text10: this.vacationExplanation,
              text11: this.privileges,
              text12: this.home,
              text13: this.neighborhood,
              text14: this.experience,
              text15: this.previousNannies,
              text20: this.pets,
              selector4: this.housekeeper,
              selector5: this.meals,
              selector6: this.travel,
              text16: this.travelExplanation,
              selector7: this.wfh,
              selector8: this.car,
              text17: this.carOther,
              text18: this.expectedHours,
              text19: this.schedule,

              available_date: this.startDate,
              marketing_source: this.referrer,

              // selector9: 'sarah@goldcoastnannies.company',
              selector9: this.$store.getters.agencyAdminEmail,

              // features2: [this.child1, this.birthday1, this.child2, this.birthday2, this.child3, this.birthday3, this.child4, this.birthday4],
            })
              .then(res => {
                console.log(res)
                this.$modal.show('application-submitted-modal')

                this.$store.dispatch('logout', 'no-redirect')

                // axios.post('/api/jobs/', {
                //   poster: this.$store.getters.userID,
                //   poster_name: this.firstName + ' ' + this.lastName,
                //   status: 'Quoted',
                //   // title: 'Mowing',
                //   description: this.note,
                //   job_type: 'Mowing',
                //   selector1: this.size,
                //   selector2: this.frequency,
                //   // date: this.startDate,
                //   // end_date: this.endDate,
                //   date: startDate,
                //   end_date: endDate,

                //   address1: this.address1,
                //   // address2: this.address2,
                //   postal_code: this.postalCode,
                //   city: this.city,
                //   provincestate: this.provinceState,
                //   country: this.country,

                //   agency: this.$store.getters.agencyID,
                //   agency_owner: this.$store.getters.agencyName,
                // })
                //   .then(res => {
                //     console.log(res)
                //     this.currentStep = 4
                //   })
                //   .catch(error => {
                //     console.log(error)
                //   })
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch(error => {
            console.log(error)
            this.$modal.show('duplicate-email-modal')
          })
      }
      else {
        // this.requiredMissing = true
        this.$modal.show('required-missing-modal')
      }
    },
    hideApplicationSubmittedModal() {
      window.location.href = 'https://www.goldcoastnannies.company/';
    },
  },
}
</script>

<style>
  .required-field {
    color: red !important;
    font-weight: 600 !important;
  }
  .required-message {
    color: red;
    font-family: 'Open Sans', 'Crimson Text';
    font-weight: 600;
    margin-top: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/employers/applications/FamilyForm.vue